import ApiService from '@/utils/ApiService'

export default {
  namespaced: true,
  state: {
    isLoading: false,
    updated: null
  },
  getters: {
    isLoading: (state) => state.isLoading,
    updated: (state) => state.updated
  },
  mutations: {
    toggleLoading (state) {
      state.isLoading = !state.isLoading
    },
    setUpdated (state, updated) {
      state.updated = updated
    },
    reset (state) {
      state.updated = null
      state.isLoading = false
    },
    setViolations (state, violations) {
      state.violations = violations
    }
  },
  actions: {
    async update ({ commit }, data) {
      commit('toggleLoading')
      const response = await new ApiService(data['@id']).put(data)
      commit('setUpdated', response)
      commit('toggleLoading')
    },
    reset ({ commit }) {
      commit('reset')
    }
  }
}
